import Transform from 'ember-data/transform';
import { isNone } from '@ember/utils';
import { camelize } from '@ember/string';
import { queryEncode, queryDecode } from 'cio/helpers/query';

export default class Base64JSONTransform extends Transform {
  deserialize(
    serialized: string | Record<string, any>,
    options?: Record<string, any>,
  ): Record<string, any> | Record<string, any>[] | null {
    try {
      if (typeof serialized === 'string') {
        return queryDecode(serialized);
      }

      if (options?.nestedKeys != null && options?.nestedKeys?.length > 0) {
        let result = {
          ...serialized,
        };
        options.nestedKeys.forEach((_key: string) => {
          let key = options.camelCase === true ? camelize(_key) : _key;
          delete result[_key];
          result[key] = queryDecode(serialized[_key]);
        });

        return result;
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  serialize(deserialized: Record<string, any>, options?: Record<string, any>): Record<string, any> | string | null {
    if (options?.nestedKeys != null && options?.nestedKeys?.length > 0) {
      let result = {
        ...deserialized,
      };
      options.nestedKeys.forEach((_key: string) => {
        let key = options.camelCase === true ? camelize(_key) : _key;
        if (!isNone(deserialized?.[key])) {
          delete result[key];
          result[_key] = queryEncode(deserialized[key]);
        }
      });
      return result;
    }
    return isNone(deserialized) ? deserialized : queryEncode(deserialized);
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'base64-json': Record<string, any> | string | null | any[];
  }
}
